import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

import { FaPhoneAlt, FaHandshake, FaRegEnvelope, FaSms } from 'react-icons/fa';
import { FaWhatsapp, FaPencilAlt, FaFileAlt, FaTrash } from 'react-icons/fa';

import CallPopup from '../call/CallPopup';
import MeetingPopup from '../meeting/MeetingPopup';
import DocumentPopup from '../meeting/DocumentPopup';

import InnerCallList from '../call/InnerCallList';
import InnerMeetingList from '../meeting/InnerMeetingList';
import InnerEmailList from '../email/InnerEmailList';
import InnerSmsList from '../sms/InnerSmsList';
import InnerDocumentList from '../document/InnerDocumentList';
import InnerContactPropertyList from '../property/InnerContactPropertyList';
import InnerWhatsAppList from '../whatsapp/InnerWhatsAppList';

import ContactDetails from './ContactDetails';
import ContactInformation from './ContactInformation';

import Util from '../../util/Util';
import ContactConst from '../../util/ContactConst';
import Const from '../../util/Constants';
import ContactAPI from '../../api/ContactAPI';
import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import withRouter from '../../util/WithRouter';
import SmsPopup from '../sms/SmsPopup';
import EmailPopup from '../email/EmailPopup';
import WhatsAppPopup from '../whatsapp/WhatsAppPopup';

import './ContactPreview.css';
import PropertyDocTable from '../document/PropertyDocTable';

class ContactPreview extends React.Component {

  constructor(props) {
    super(props);

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.contact;
    this.id = parseInt(props.match.params.contactId);

    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/preview'));

    this.state = {
      inApiCall: this.id !== 0, popup: null,
      call: null, meeting: null, document: null, email: 0, sms: 0, whatsApp: 0
    };

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.CallList = Util.isAllow(this.models.call.permission, Const.PermView);
    this.CallAdd = Util.isAllow(this.models.call.permission, Const.PermAdd);

    this.CallUpdate = Util.isAllow(this.models.call.permission, Const.PermUpdate);

    this.MeetList = Util.isAllow(this.models.meeting.permission, Const.PermView);
    this.MeetAdd = Util.isAllow(this.models.meeting.permission, Const.PermAdd);
    this.MeetUpdate = Util.isAllow(this.models.meeting.permission, Const.PermUpdate);

    this.DocList = Util.isAllow(this.models.document.permission, Const.PermView);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);

    this.SmsList = Util.isAllow(this.models.sms.permission, Const.PermView);
    this.SmsAdd = Util.isAllow(this.models.sms.permission, Const.PermAdd);

    this.EmailList = Util.isAllow(this.models.email.permission, Const.PermView);
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);

    this.SalesList = Util.isAllow(this.models.sales_order.permission, Const.PermView);
    this.SalesAdd = Util.isAllow(this.models.sales_order.permission, Const.PermAdd);

    this.WhatsAppList = Util.isAllow(this.models.contact.permission, Const.PermView);
    this.WhatsAppAdd = Util.isAllow(this.models.contact.permission, Const.PermAdd);

    this.PropertyList = Util.isAllow(this.models.property.permission, Const.PermView);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.id !== parseInt(props.match.params.contactId)) {
      this.id = parseInt(props.match.params.contactId);
      let dummy = { ...this.state };
      if (dummy.call) { dummy.call.model_no = Const.Contact; dummy.call.model_id = this.id; }
      if (dummy.meeting) { dummy.meeting.model_no = Const.Contact; dummy.meeting.model_id = this.id; }
      if (dummy.document) { dummy.document.model_no = Const.Contact; dummy.document.model_id = this.id; }
      if (dummy.email) { dummy.email.model_no = Const.Contact; dummy.email.model_id = this.id; }
      if (dummy.sms) { dummy.sms.model_no = Const.Contact; dummy.sms.model_id = this.id; }
      ContactAPI.get(this.id, this.onReceived, this.onFail);
    }
  }

  componentDidMount() { if (this.id !== 0) { ContactAPI.get(this.id, this.onReceived, this.onFail); } }

  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };

  onReceived = res => {
    this.contact = res;
    this.contactName = '';
    if (res.firstname !== undefined && res.firstname !== null) {
      this.contactName = res.firstname;
    }
    if (res.middlename !== undefined && res.middlename !== null) {
      this.contactName += this.contactName !== '' ? ' ' + res.middlename : res.middlename;
    }
    if (res.lastname !== undefined && res.lastname !== null) {
      this.contactName += this.contactName !== '' ? ' ' + res.lastname : res.lastname;
    }
    this.setState({ ...this.state, inApiCall: false });
  };

  onUpdate = () => {
    this.setState({ ...this.state, inApiCall: true });
    ContactAPI.get(this.id, this.onReceived, this.onFail);
  };

  onDelete = () => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.contact)}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ContactAPI.delete(this.id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Contact deleted successfully', 'success');
    this.props.navigate('/contact');
  };

  updateMater = () => {
    this.setState({ inApiCall: true, popup: null });
    ContactAPI.get(this.id, this.onReceived, this.onFail);
  };
onEditProperty = (property) => {
  this.props.navigate(`/property/add-edit/${property.id}`);
};

  showDetails = (model, field) => {
    if (field === ContactConst.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    }
  };
  showPopUp = (model, field) => {
    if (field === ContactConst.SalesOrder) {
      this.props.navigate(`/sales-order/add-edit/1/${this.id}/${model}`);
      return;
    } 
    let tmp = { ...this.state };
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp });
  };
  hidePopUp = () => this.setState({ ...this.state, popup: ContactConst.Refresh });

  render() {
    let param = {};
    const EmailOpt = this.contact && this.contact.email_opt && this.contact.email_opt === Const.True;
    const SmsOpt = this.contact && this.contact.sms_opt && this.contact.sms_opt === Const.True;

    const CallPopUp = (this.CallAdd || this.CallUpdate) ?
      <CallPopup
        show={this.state.popup === ContactConst.Call} onHide={this.hidePopUp} call={this.state.call}
        reload={this.updateMater} model_no={Const.Contact} model_id={this.id} contact={this.contact} /> : null;
    const MeetingPopUp = (this.MeetAdd || this.MeetUpdate) ?
      <MeetingPopup show={this.state.popup === ContactConst.Meeting} onHide={this.hidePopUp}
        meeting={this.state.meeting} reload={this.updateMater} model_no={Const.Contact} model_id={this.id}
        contact={this.contact} /> : null;
    const DocumentPopUp = this.DocAdd ?
      <DocumentPopup show={this.state.popup === ContactConst.Document} onHide={this.hidePopUp}
        document={this.state.document}
        reload={this.updateMater} model_no={Const.Contact} model_id={this.id} /> : null;
    const SmsPopUp = this.SmsAdd ?
      <SmsPopup show={this.state.popup === ContactConst.SMS} onHide={this.hidePopUp}
        data={this.contact} model={this.model}
        reload={this.updateMater} model_no={Const.Contact} model_id={this.id} /> : null;
    const EmailPopUp = this.EmailAdd ?
      <EmailPopup show={this.state.popup === ContactConst.Email} onHide={this.hidePopUp}
        data={this.contact} model={this.model}
        reload={this.updateMater} model_no={Const.Contact} model_id={this.id} /> : null;

    const CallButton = this.CallAdd ?
      <span className="buttons call" variant="primary"
        onClick={() => this.showPopUp(null, ContactConst.Call)}><FaPhoneAlt /> Call</span> : null;
    const MeetButton = this.MeetAdd ?
      <span className="buttons meeting" variant="primary" onClick={() =>
        this.showPopUp(null, ContactConst.Meeting)}><FaHandshake /> Meeting</span> : null;
    const DocButton = this.DocAdd ?
      <span className="buttons junk" variant="primary"
        onClick={() => this.showPopUp(null, ContactConst.Document)}><FaFileAlt /> Doc</span> : null;
    const SmsButton = this.SmsAdd && !SmsOpt ?
      <span className="buttons sms" variant="primary"
        onClick={() => this.showPopUp({}, ContactConst.SMS)}><FaSms /> SMS</span> : null;
    const EmailButton = this.EmailAdd && !EmailOpt ?
      <span className="buttons email" variant="primary"
        onClick={() => this.showPopUp({}, ContactConst.Email)}><FaRegEnvelope /> Email</span> : null;
    const UpdateButton = this.Update ?
      <span className="buttons update" variant="primary">
        <NavLink to={`${this.base}/add-edit/${this.id}`}><FaPencilAlt /> Update</NavLink>
      </span> : null;
    const DeleteButton = this.Delete ?
      <span className="buttons delete" onClick={this.onDelete}><FaTrash /> Delete</span> : null;

    const CallList = this.CallList ?
      <InnerCallList id={this.id} type={Const.Contact} {...param} reload={this.updateMater}
        edit={this.showPopUp} /> : null;
    const MeetList = this.MeetList ?
      <InnerMeetingList id={this.id} type={Const.Contact} {...param} edit={this.showPopUp}
        reload={this.updateMater} /> : null;
    const DocList = this.DocList ?
      <PropertyDocTable id={this.id} type={Const.Contact} {...this.props} reload={this.props.reload} /> : null;
    // <InnerDocumentList id={this.id} type={Const.Contact} {...param} 
    //   reload={this.updateMater}/> : null;
    const SmsList = this.SmsAdd ?
      <InnerSmsList id={this.id} type={Const.Contact} {...param} reload={this.updateMater} /> : null;
    const EmailList = this.EmailList ?
      <InnerEmailList id={this.id} type={Const.Contact} {...param} reload={this.updateMater} /> : null;

    const PropertyList = this.PropertyList ? <InnerContactPropertyList id={this.id}
      {...param} reload={this.updateMater} edit={this.onEditProperty}/> : null;
    const WhatsAppList = this.WhatsAppList ?
      <InnerWhatsAppList id={this.id} type={Const.Contact} {...param} reload={this.updateMater} /> : null;

    return (
      <section className="previewpage">
        <ApiUiController inApiCall={this.state.inApiCall}>
          {CallPopUp}
          {MeetingPopUp}
          {DocumentPopUp}
          {SmsPopUp}
          {EmailPopUp}
          <WhatsAppPopup show={this.state.popup === ContactConst.WhatsApp} onHide={this.hidePopUp}
            data={this.contact} model={this.model} />

          <div className="container-fluid">
            <div className="row lead-mt">
              <div className="col-md-4">
                <div className="title_page"><h2>Contact - {this.contactName}</h2></div>
              </div>
              <div className="col-md-8 lead-btns-col">
                <span className="action-btns-lg">
                  {CallButton}
                  {MeetButton}
                  {DocButton}
                  {SmsButton}
                  {EmailButton}
                  <span className="buttons whtsapp" variant="primary"
                    onClick={() => this.showPopUp({}, ContactConst.WhatsApp)}><FaWhatsapp /> WhatsApp
                  </span>
                  {UpdateButton}
                  {DeleteButton}
                </span>
              </div>
            </div>

            <div className="row tablesrow">
              <div className="col-md-12">
                <ContactDetails model={this.model} contact={this.contact} contactName={this.contactName} />
                <ContactInformation model={this.model} contact={this.contact} />
                { /* <ContactProgress /> */}
                {CallList}
                {MeetList}
                {DocList}
                {SmsList}
                {EmailList}
                {PropertyList}
                {WhatsAppList}
              </div>
              { /* <LeadTimeline /> */}
            </div>
          </div>
        </ApiUiController>
      </section>
    );
  }
}
export default withRouter(ContactPreview);